import { Configuration } from "vmd-types";

type ItemName = Exclude<Configuration["itemName"], undefined>;

/**
 * Display name used only in the "create new item" flow (dialog title and its
 * entry-point buttons): "DC System" reads as "DC Business App" there, matching
 * how it's already displayed elsewhere (e.g. the report page's item tab), while
 * every other occurrence of the stored `itemName` (charts, overview titles,
 * table headers) keeps showing the configured value unchanged.
 */
export function getItemCreationDisplayName(itemName?: ItemName): string {
  if (itemName === "DC System") {
    return "DC Business App";
  }

  return itemName ?? "Tracking Item";
}
